import { Injectable } from '@angular/core';
import { ToastNotifyService } from '@app/pages/notifications/services/toast-notify.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AlertService {
  constructor(
    private toastNotify: ToastNotifyService,
    private translate: TranslateService
  ) { }

  public openSuccessAlert(message: string): any {
    return this.toastNotify.showSuccess(this.translateWithFallback('SYSTEM.ACTION.SUCCESS', 'Success'), message);
  }

  public openErrorAlert(message: string): any {
    return this.toastNotify.showError(this.translateWithFallback('SYSTEM.ACTION.FAILURE', 'Error'), message);
  }

  public openInfoAlert(message: string): any {
    return this.toastNotify.showInfo(this.translateWithFallback('SYSTEM.ACTION.INFO', 'Info'), message);
  }

  private translateWithFallback(key: string, fallback: string): string {
    const value = this.translate.instant(key);
    return value && value !== key ? value : fallback;
  }
}

